<template>
  <v-flex>
    <client-form :client-id="selectedClientId" />
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import ClientForm from './ClientForm.vue'

export default {
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    selectedClientId: function() {
      return +this.clientId
    },
  },
  data() {
    return {}
  },
  components: {
    ClientForm,
  },
}
</script>
